<div
    class="dropdown shrink-0"
    *ngIf="user$ | async as user; else noUser"
>
    <div
        hlMenu
        class="!block"
    >
        <button
            type="button"
            hlMenuButton
            class="group relative block"
        >
            <img
                class="h-9 w-9 rounded-full object-cover saturate-50 group-hover:saturate-100"
                [src]="user.profilePicture || defaultProfilePicture"
                alt="user profile"
            />
        </button>

        <ul
            *hlMenuItems
            @toggleAnimation
            class="top-11 w-[230px] !py-0 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0"
        >
            <li>
                <div class="flex items-center px-4 py-4">
                    <div class="flex-none">
                        <img
                            class="h-10 w-10 rounded-md object-cover"
                            [src]="user.profilePicture || defaultProfilePicture"
                            alt="user"
                        />
                    </div>
                    <div class="truncate ltr:pl-4 rtl:pr-4">
                        <h4 class="text-base">
                            {{ user.name }}
                        </h4>
                        <a
                            class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white"
                            href="javascript:void(0)"
                        >
                            {{ user.email }}
                        </a>
                    </div>
                </div>
            </li>

            <li>
                <a
                    routerLink="/perfil"
                    *hlMenuItem
                    class="dark:hover:text-white"
                >
                    <icon-user class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                    Meu Perfil
                </a>
            </li>

            <!-- <li>
                <a routerLink="/apps/mailbox" *hlMenuItem class="dark:hover:text-white">
                    <icon-mail class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                    Inbox
                </a>
            </li>

            <li>
                <a routerLink="/auth/boxed-lockscreen" *hlMenuItem class="dark:hover:text-white">
                    <icon-lock-dots class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                    Lock Screen
                </a>
            </li> -->

            <li class="border-t border-white-light dark:border-white-light/10">
                <a
                    (click)="logout()"
                    class="!py-3 text-danger cursor-pointer"
                    *hlMenuItem
                >
                    <icon-logout class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2" />
                    Sair
                </a>
            </li>
        </ul>
    </div>
</div>

<ng-template #noUser>
    <p>Usuário não carregado</p>
</ng-template>
